import { createContext, useRef, useCallback } from 'react'

import { REGIONS } from '../constants/telemetryEvents'

export const RegionContext = createContext()

export const RegionProvider = ({ children }) => {
  const regionsRef = useRef({}) 

  // 1. Components call this to report their position
  const updateRegion = useCallback((id, rect) => {
    regionsRef.current[id] = rect
  }, [])

  // 2. Components call this when they unmount
  const removeRegion = useCallback((id) => {
    delete regionsRef.current[id]
  }, [])

  // 3. The "Lookup" function for your Telemetry
  const getRegionName = useCallback((x, y) => {
    let bestMatch = REGIONS.BACKGROUND
    let maxPriority = -1 

    const mouseX = Number(x)
    const mouseY = Number(y)

    for (const [name, rect] of Object.entries(regionsRef.current)) {
      // 1. Check if point is inside (Comparing 0.0-1.0 to 0.0-1.0)
      if (
        mouseX >= rect.left &&
        mouseX <= rect.right &&
        mouseY >= rect.top &&
        mouseY <= rect.bottom
      ) {
        // 2. Priority Check
        if (rect.priority > maxPriority) {
           maxPriority = rect.priority
           bestMatch = name
        }
      }
    }
    return bestMatch 
  }, []) 

  return (
    <RegionContext.Provider value={{ updateRegion, removeRegion, getRegionName }}>
      {children}
    </RegionContext.Provider>
  )
}